/**
 * Puts the suggested "Prorated Amount" into a lease form's one-time charges.
 *
 * A positive amount fills the prorated row (or the first empty row, or a new
 * row). Zero means there is nothing to prorate, so the prorated row is left
 * blank and no row is added. A prorated charge that has already been paid is
 * never changed.
 *
 * @param {Array<Object>} charges the form's one-time charges
 * @param {string|number} proratedAmount the amount from calculate-prorated-amount
 * @returns {Array<Object>} the charges to put back on the form
 */
export function applyProratedAmount(charges, proratedAmount) {
    const index = charges.findIndex((charge) => charge.type === 2);
    if (index !== -1 && charges[index].payment) {
        return charges;
    }

    const next = [...charges];

    if (!(parseFloat(proratedAmount) > 0)) {
        if (index !== -1) {
            next[index] = { ...next[index], amount: null };
        }
        return next;
    }

    const prorated = { title: 'Prorated Amount', amount: proratedAmount, type: 2 };

    if (index !== -1) {
        next[index] = { ...next[index], ...prorated };
    } else if (next[0] && next[0].title === null && next[0].amount === null) {
        next[0] = { ...next[0], ...prorated };
    } else {
        next.push({ key: next.length + 1, due_date: null, ...prorated });
    }

    return next;
}
